import React from 'react'
import Events from '../../content/Events'

const WhatsNext = (props) => {
  return <Events {...props} title="What's Next" />
}

export default WhatsNext
